import { useEffect, useRef } from "react";
import { msalInstance } from "./authConfig"; // Your MSAL configuration file

const useAutoLogout = (timeout = 60 * 60 * 1000) => { // Default 1 hour
    const timeoutRef = useRef(null);
    const countdownIntervalRef = useRef(null);
    // const sessionIntervalRef = useRef(null);

    // const sessionStartRef = useRef(Date.now());
    const remainingTimeRef = useRef(timeout); // Remaining time for auto-logout

    const resetTimer = () => {
        // Clear and reset the logout timer
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);

        remainingTimeRef.current = timeout;

        timeoutRef.current = setTimeout(() => {
            handleLogout();
        }, timeout);

        // Log countdown every second
        countdownIntervalRef.current = setInterval(() => {
            remainingTimeRef.current -= 1000;

            // const minutes = Math.floor(remainingTimeRef.current / 60000);
            // const seconds = ((remainingTimeRef.current % 60000) / 1000).toFixed(0);
            // console.log(`⏳ Auto logout in: ${minutes}m ${seconds}s`);

            if (remainingTimeRef.current <= 0) {
                clearInterval(countdownIntervalRef.current);
            }
        }, 1000);
    };

    const handleLogout = async () => {
        try {
            console.log("🔒 User is idle, logging out...");
            await msalInstance.initialize();
            localStorage.clear();
            window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
        } catch (error) {
            console.error("❌ MSAL logout failed:", error);
            localStorage.clear();
            window.location.reload();
        }
    };

    useEffect(() => {
        const activityEvents = ["keydown", "mousedown", "touchstart"];
        const handleActivity = () => resetTimer();

        // Set up activity listeners
        activityEvents.forEach((event) =>
            window.addEventListener(event, handleActivity)
        );

        // Start the initial countdown and session timer
        resetTimer();

        // Track actual session duration
        // sessionIntervalRef.current = setInterval(() => {
        //     // const elapsed = Date.now() - sessionStartRef.current;
        //     // const minutes = Math.floor(elapsed / 60000);
        //     // const seconds = Math.floor((elapsed % 60000) / 1000);
        //     // console.log(`🟢 Actual session time: ${minutes}m ${seconds}s`);
        // }, 1000);

        // Clean up
        return () => {
            clearTimeout(timeoutRef.current);
            clearInterval(countdownIntervalRef.current);
            // clearInterval(sessionIntervalRef.current);
            activityEvents.forEach((event) =>
                window.removeEventListener(event, handleActivity)
            );
        };
    }, [timeout]);

    return null;
};

export default useAutoLogout;
